// reference: https://www.npmjs.com/package/http-status-codes#codes

export const statusCode = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,

  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,

  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  SERVICE_UNAVAILABLE: 503,
} as const

export const headers = {
  ACCESS_TOKEN: 'X-LM-AUTH-TOKEN',
  APPLICATION_JSON: 'application/json',
  CONTENT_TYPE: 'Content-Type',
} as const
